import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

interface GalleryImage {
    id: number;
    title: string;
    description: string;
    color: string;
    icon: string;
}

@Component({
    selector: 'demo-upp-visible-control',
    templateUrl: './demo-upp-visible-control.html',
    styleUrls: ['../demo-common.scss', './demo-upp-visible-control.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppVisibleControlComponent {
    images: GalleryImage[] = [
        { id: 1, title: 'Mountain Sunrise', description: 'Golden light over snowy peaks', color: '#e8a87c', icon: 'sunny-outline' },
        { id: 2, title: 'Ocean Waves', description: 'Crashing waves at sunset', color: '#85cdca', icon: 'water-outline' },
        { id: 3, title: 'Forest Path', description: 'Mossy trail through old-growth woods', color: '#7bc67e', icon: 'leaf-outline' },
        { id: 4, title: 'City Skyline', description: 'Neon lights reflecting on glass', color: '#6c7b95', icon: 'business-outline' },
        { id: 5, title: 'Desert Dunes', description: 'Windswept sand under a clear sky', color: '#d4a76a', icon: 'partly-sunny-outline' },
        { id: 6, title: 'Northern Lights', description: 'Aurora dancing over a frozen lake', color: '#7f8fa6', icon: 'planet-outline' },
        { id: 7, title: 'Cherry Blossoms', description: 'Pink petals lining a quiet street', color: '#e6a1b0', icon: 'flower-outline' },
        { id: 8, title: 'Waterfall', description: 'Cascading water in a tropical jungle', color: '#63b3ed', icon: 'water-outline' },
        { id: 9, title: 'Starry Night', description: 'Milky way visible from a hilltop', color: '#4a5568', icon: 'moon-outline' },
        { id: 10, title: 'Autumn Leaves', description: 'Red and orange canopy over a park', color: '#c0765a', icon: 'leaf-outline' },
        { id: 11, title: 'Coral Reef', description: 'Vibrant marine life underwater', color: '#48c9b0', icon: 'fish-outline' },
        { id: 12, title: 'Lavender Field', description: 'Purple rows stretching to the horizon', color: '#9b7fbd', icon: 'flower-outline' },
        { id: 13, title: 'Glacial Lake', description: 'Turquoise water surrounded by ice', color: '#74b9ff', icon: 'snow-outline' },
        { id: 14, title: 'Volcanic Crater', description: 'Steaming crater at dawn', color: '#a0522d', icon: 'flame-outline' },
        { id: 15, title: 'Bamboo Grove', description: 'Tall bamboo swaying in the breeze', color: '#81b29a', icon: 'leaf-outline' },
    ];

    visibilityMap: boolean[] = new Array(15).fill(false);
    visibleCount = 0;

    constructor(private change: ChangeDetectorRef) {}

    onVisibilityChange(index: number, isVisible: boolean) {
        this.visibilityMap[index] = isVisible;
        this.visibleCount = this.visibilityMap.filter(v => v).length;
        this.change.markForCheck();
    }
}
